import gettext from '@sdk/lang/gettext';

import { RatingInfluenceStep } from '@web/components/npsScore/RatingInfluenceStep/RatingInfluenceStep';
import { NpsSteps, STEPS_CONFIG } from '@web/components/npsScore/constants';
import NpsRateStep from '@web/components/npsScore/NpsRateStep/NpsRateStep';
import SurveyCommentStep from '@web/components/survey/SurveyCommentStep';
import SurveyFinishStep from '@web/components/survey/SurveyFinishStep';
import SurveyStep from '@web/components/survey/SurveyStep';
import BookCall from '@web/components/survey/BookCall';
import { BOOK_CALL_DEFAULT_SLING_PM, BOOK_CALL_SCHEDULE_EXPERIENCE_PM } from '@web/constants';

import { useNpsScoreSteps } from './npsScoreSteps.hooks';

type Props = {
  submitForm: () => void;
  closeNps: () => void;
  onPositiveRate: () => void;
};

const NpsScoreSteps = ({ submitForm, onPositiveRate, closeNps }: Props) => {
  const { step, npsScore, scoreComment, setScoreComment, onSetScore, nextStep, influence } =
    useNpsScoreSteps({
      onPositiveRate,
      submitForm,
    });

  if (step === NpsSteps.rate) {
    return <NpsRateStep score={npsScore} onSetScore={onSetScore} submitStep={nextStep} />;
  }

  if (step === NpsSteps.influence) {
    return <RatingInfluenceStep submitStep={nextStep} />;
  }

  if (step === NpsSteps.comment1) {
    const currentStep = STEPS_CONFIG[NpsSteps.comment1];
    return (
      <SurveyCommentStep
        comment={scoreComment}
        setComment={setScoreComment}
        submitStep={nextStep}
        text={gettext(currentStep.text)}
        submitLabel={gettext(currentStep.submitLabel)}
      />
    );
  }

  if (step === NpsSteps.finish) {
    const currentStep = STEPS_CONFIG[NpsSteps.finish];
    return (
      <SurveyFinishStep
        title={gettext(currentStep.title)}
        subtitle={gettext(currentStep.subtitle)}
        closeSurvey={closeNps}
      />
    );
  }

  if (step === NpsSteps.finishCall) {
    const callUrl =
      influence === 'Employee scheduling'
        ? BOOK_CALL_SCHEDULE_EXPERIENCE_PM
        : BOOK_CALL_DEFAULT_SLING_PM;
    return (
      <SurveyStep>
        <BookCall bookCallUrl={callUrl} />
      </SurveyStep>
    );
  }

  return null;
};

export default NpsScoreSteps;
